export const PLANNED_VISITS_TYPE = {
  NORMAL: 1,
  REPLACEMENT: 2,
  EMERGENCY: 3,
  REPEATED: 4
};

export const VISITS_TYPE = {
  NORMAL: 1,
  REPLACEMENT: 2,
  EMERGENCY: 3,
  REPEATED: 4
};

export const VISIT_STATUS = {
  COMPLETED: 1,
  PLANNED: 2,
  NOT_COMPLETED: 3,
  NOT_LINKED: 4,
  UNPRODUCTIVE: 5,
  LATE: 110, // status not indicated in visitStatus consts because it is a temporal status.
  IN_PROGRESS: 220 // status not indicated in visitStatus consts because it is a temporal status.
};

export const PERFORMED_RESIDENCE = {
  INSIDE: { translate: 'Na residência', value: 1 },
  OUTSIDE: { translate: 'Fora da residência', value: 2 }
};
